/**
 * Audio Recording Service - Web platform exports
 */

// Re-export types and errors from the base interface
export type { AudioFile, AudioRecordingService } from './audioRecordingService';
export { RecordingState, PermissionDeniedError, InvalidRecordingStateError, RecordingStartError } from './audioRecordingService';

// Export web-specific service instance
export { audioRecordingService } from './audioRecordingService.web';
